export default "__VITE_ASSET__BAA9$jYI__"